import isToday from 'date-fns/isToday';
import isTomorrow from 'date-fns/isTomorrow';

import { getTranslation, keys } from '../../Resources/Translations';

const locales = 'nb-NO';
const timeZone = 'Europe/Oslo';

export enum FormatDateOptions {
    DateOnly,
    DateWithWeekday,
    DateWithTodayTomorrowWeekday
}

export function formatDate(date: string, withoutDay?: boolean): string {
    const d = new Date(date);
    const weekday = d.toLocaleDateString(locales, { weekday: 'short' }).slice(0, -1); // omit the dot
    return withoutDay ? d.toLocaleDateString(locales) : `${weekday}, ${d.toLocaleDateString(locales)}`;
}

export function formatDateShort(date: string): string {
    const d = new Date(date);
    return d.toLocaleDateString(locales, { month: 'short', day: 'numeric' }).replace('.', '');
}

export function formatDateNumeric(date: string): string {
    const d = new Date(date);
    return d.toLocaleDateString(locales, { month: '2-digit', day: '2-digit', year: 'numeric' });
}

export function formatDateLong(dateString: string, format: FormatDateOptions = FormatDateOptions.DateOnly, convertTimezone?: boolean): string {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString(locales, { month: 'long', day: 'numeric', timeZone: convertTimezone ? timeZone : undefined });
    if (format === FormatDateOptions.DateOnly) {
        return formattedDate;
    }

    return `${getWeekDay(date, format === FormatDateOptions.DateWithTodayTomorrowWeekday)}, ${formattedDate}`;
}

export function formatTimeFromDate(date: string, convertTimezone?: boolean): string {
    const d = new Date(date);
    return d.toLocaleTimeString(locales, { hour: '2-digit', minute: '2-digit', timeZone: convertTimezone ? timeZone : undefined });
}

export function formatTime(time: string) {
    return time ? time.slice(0, 2) + ':' + time.slice(2) : null;
}

function getWeekDay(date: Date, replaceTodayTomorrow: boolean, format: Intl.DateTimeFormatOptions['weekday'] = 'long'): string {
    if (replaceTodayTomorrow) {
        if (isToday(date)) {
            return getTranslation(keys['checkout.delivery.today']);
        } else if (isTomorrow(date)) {
            return getTranslation(keys['checkout.delivery.tomorrow']);
        }
    }

    return date.toLocaleDateString(locales, { weekday: format });
}
